// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-16 {
  height: 4rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-24 {
  height: 6rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-16 {
  width: 4rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-24 {
  width: 6rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-\\[411px\\] {
  max-width: 411px;
}
.max-w-\\[482px\\] {
  max-width: 482px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-lg {
  max-width: 32rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.place-items-center {
  place-items: center;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.place-self-center {
  place-self: center;
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.overflow-hidden {
  overflow: hidden;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#FFF6F6\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 246 246 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFF6F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 246 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-black\\/80 {
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.p-10 {
  padding: 2.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.\\!px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-\\[16px\\] {
  font-size: 16px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-semibold {
  font-weight: 600;
}
.leading-\\[1\\.1\\] {
  line-height: 1.1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}

/* Avenir Font Family - Using system fonts as fallback for now */

:root {
  --container: 1440px;
  --text: #0e0e0e;
  --muted: #5b5b5b;
  --bg: #ffffff;
  --primary: #e31b23;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  color: var(--text);
  background: var(--bg);
  overflow-x: hidden;
  /* prevent mobile horizontal slider */
  scroll-behavior: smooth;
}

#root {
  min-height: 100dvh;
}

.container {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 16px;
}

/* Header */
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: saturate(180%) blur(10px);
  border-bottom: 1px solid #eee;
  margin: 0 auto;
}

.header-inner {
  display: flex;
  max-width: 1520px;
  margin: 0 auto;
  align-items: center;
  gap: 24px;
  padding: 7px 16px;
  position: relative;
}

.nav-toggle {
  margin-left: auto;
  display: none;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.nav-toggle:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.nav-toggle .nav-toggle-bar {
  display: block;
  width: 20px;
  height: 2px;
  background: #111;
  position: relative;
  transition: all 0.3s ease;
  transform-origin: center;
}

.nav-toggle .nav-toggle-bar:nth-child(2) {
  margin: 0;
}

/* Hamburger to X animation when menu is open */
.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.brand img {
  display: block;
  width: clamp(100px, 18vw, 247px);
  height: auto;
  max-height: 70px;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .site-header .container {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: 5%;
}

.main-nav {
  display: flex;
  gap: 80px;
  flex-grow: 2;
}

.main-nav a {
  white-space: nowrap;
  color: var(--text);
  text-decoration: none;
  font-weight: 600;
  position: relative;
  padding-bottom: 8px;
}

.main-nav a:hover {
  color: var(--primary);
}

.main-nav a.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--primary);
  border-radius: 2px;
}

.search {
  display: inline-flex;
  align-items: center;
  gap: 0;
  justify-self: flex-end;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 999px;
  padding: 2px;
  background: #fff;
  transition: box-shadow .2s ease;
}

.search:focus-within {
  box-shadow: 0 0 0 3px rgba(227, 27, 35, .12);
}

.search input {
  padding: 8px 12px;
  border: none;
  outline: none;
  font-size: 14px;
  width: 120px;
  transition: width .25s ease;
}

.search-btn {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #8c8c8c;
  cursor: pointer;
}

.search-btn:hover {
  color: #555;
}

.search:focus-within input {
  width: 200px;
}

/* Mobile nav behavior */
@media (max-width: 800px) {
  .site-header {
    overflow: visible;
  }

  .nav-toggle {
    display: inline-flex;
    margin-left: auto;
    order: 3;
  }

  .header-inner {
    position: relative;
    justify-content: space-between;
    padding: 7px 16px;
    overflow: visible;
  }

  .brand {
    order: 1;
    flex-shrink: 0;
  }

  .header-right {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    width: 100%;
    z-index: 1001;
    margin: 0;
    padding: 0;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    padding-left: calc(50vw - 50%);
    padding-right: calc(50vw - 50%);
  }

  .search {
    display: none;
  }

  .main-nav {
    position: relative;
    display: grid;
    gap: 0;
    background: #fff;
    border-bottom: 1px solid #eee;
    transform-origin: top;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    width: 100%;
    margin: 0;
    padding: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .site-header.is-open .main-nav {
    max-height: 400px;
  }

  .main-nav a {
    padding: 14px 24px;
    border-top: 1px solid #f2f2f2;
    display: block;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
  }

  .main-nav a:first-child {
    border-top: none;
  }
}

/* Desktop spacing */
@media (min-width: 801px) {
  .header-inner {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 24px;
  }

  .main-nav {
    margin: 0;
    justify-self: center;
  }

  .search {
    justify-self: end;
  }
}

/* Hero */
.hero {
  position: relative;
  padding: 140px 0 120px;
  color: #fff;
  min-height: 100vh;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: var(--hero-bg);
  background-size: cover;
  background-position: center calc(50% + var(--parallax-offset, 0px));
  background-repeat: no-repeat;
  z-index: 0;
  will-change: background-position;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
}

.hero-inner {
  position: relative;
  height: 70vh;
  /* full viewport height */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* this moves content to the bottom */
  /* keeps it left-aligned */
  z-index: 2;
  width: 100%;
  padding-bottom: 4rem;
  /* add some space from the bottom */
}

.hero h1 {
  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;
  font-weight: 900;
  font-style: normal;
  font-size: 79px;
  line-height: 100%;
  letter-spacing: 0;
  margin: 0 0 16px;
  /* Constrain heading width for consistent wrapping across pages */
  max-width: 900px;
}

.lead {
  color: #f0f0f0;
  margin: 0;
  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  flex: 1 1;
  /* Constrain body copy width so CTA alignment matches home */
  max-width: 560px;
}

.hero-content-row {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 16px;
}

.hero-cta {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-shrink: 0;
}

.hero-cta:hover .btn-primary,
.hero-cta:hover .btn-circle {
  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);
}

.hero-cta:hover .btn-circle {
  transform: translateX(6px);
}


/* Prevent CTA text wrapping in hero */
.hero-cta .btn-primary {
  white-space: nowrap;
  border-radius: 30px 10px 10px 30px !important;
  height: clamp(48px, 7vw, 56px);
  padding: 12px clamp(24px, 4.2vw, 36px);
}

/* Make the arrow button a rounded square in the hero CTA */
.hero-cta .btn-circle {
  border-radius: 0px 10px 10px 0px !important;
  /* border-radius: 8px; */
  width: clamp(48px, 7vw, 56px);
  height: clamp(48px, 7vw, 56px);
}


/* Sections */
.section {
  padding: 80px 0;
}

.section.alt {
  background: #f8f9fb;
}

.section h2 {
  font-size: 32px;
  margin: 0 0 24px;
}

/* Services Core Logistics - 100vh split layout with pinned left */
.services-core-logistics {
  padding: 0;
}

.core-logistics-sticky-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  min-height: 100vh;
}

.core-logistics-left {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 24px;
}

.core-logistics-right {
  position: relative;
  padding: 80px 24px;
}

.service-showcase-item {
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
}

.service-showcase-item .service-image img {
  display: block;
  width: 100%;
  height: auto;
}

@media (min-width: 1024px) {
  .core-logistics-left {
    padding: 120px 48px;
  }

  .core-logistics-right {
    padding: 120px 48px;
  }
}

/* Accordions (keep bg #FFF6F6 only) */
.accordion {
  margin-top: 16px;
}

.accordion-item {
  background: #FFF6F6;
  border: none;
  border-radius: 12px;
  margin: 12px 0;
  overflow: hidden;
  transition: background-color .2s ease;
}

.accordion-item.is-open {
  background: #FFCBCD;
}

.accordion-header {
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #FFF6F6;
  border: none;
  cursor: pointer;
}

.accordion-item.is-open .accordion-header {
  background: #FFCBCD;
}

.accordion-header .acc-bullet {
  width: 8px;
  height: 8px;
  background: #E31B23;
  border-radius: 50%;
}

.accordion-header .acc-label {
  color: #E31B23;
  font-weight: 700;
}

.acc-toggle {
  display: inline-flex;
  transition: transform .2s ease;
}

.acc-toggle.rot-180 {
  transform: rotate(180deg);
}

.accordion-content {
  background: #FFF6F6;
  transition: max-height .25s ease;
}

.accordion-item.is-open .accordion-content {
  background: #FFCBCD;
}

.accordion-content-inner {
  padding: 0 16px 14px 36px;
  color: #5b5b5b;
}


.rec-card {
  background: #FFCBCD;
  gap: 24px;
  width: 100%;
  position: relative;
  margin: 15% 0 15% 0;
  padding: 8% 6%;
  border-radius: 16px;
}

/* subtle world map watermark */
.rec-card .rec-bg {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  background-size: cover;
  background-position: center;
  pointer-events: none;
  z-index: 0;
}

.rec-copy {
  position: relative;
  z-index: 2;
}

.rec-copy h2 {
  font-size: clamp(28px, 3.6vw, 48px);
  line-height: 1.1;
  margin: 0 0 12px;
  font-weight: 700;
}

.rec-copy .accent {
  color: var(--primary);
}

.rec-copy .muted {
  color: var(--muted);
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 600;
}

.rec-actions {
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

/* contact button and arrow pair styling */
.btn.btn-outline {
  border-color: #e5a5aa;
  color: #111;
  background: #fff;
}

.rec-actions .btn-circle {
  width: 46px;
  height: 46px;
  background: #fff;
  color: #e01d2c;
}

.rec-actions .btn-outline:hover,
.rec-actions .btn-circle:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(227, 27, 35, .18);
}

/* colored bars behind the person image */
.flag-bars {
  position: absolute;
  right: 10%;
  bottom: 15%;
  width: clamp(180px, 22vw, 420px);
  display: grid;
  gap: 6px;
  z-index: 0;
}

.flag-bars .bar {
  height: clamp(46px, 6vw, 68px);
  border-radius: 0;
}

.flag-bars .bar-red {
  background: #e01d2c;
}

.flag-bars .bar-blue {
  background: #1938a5;
}

.flag-bars .bar-green {
  background: #1a8f3a;
}


.rec-media {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50%;
  max-width: 689px;
  z-index: 1;
}

.rec-media img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
}

@media (max-width: 900px) {
  .rec-card {
    grid-template-columns: 1fr;
    text-align: left;
  }

  .rec-media img {
    margin: 0 auto;
  }


}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 999px;
  border: 1px solid transparent;
  text-decoration: none;
  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;
  font-weight: 600;
}

.btn-primary {
  /* background: linear-gradient(180deg, #ED1B24 0%, #870F15 100%); */
  color: #fff;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  border: 1px solid #ED1B24;
  border-radius: 30px !important;
  /* box-shadow: 0 4px 12px rgba(237, 27, 36, 0.3); */
  transition: all 0.3s ease;
  height: 48px;
  display: flex;
  align-items: center;
}



.btn-circle {
  width: 48px;
  height: 48px;
  border: 1px solid #ED1B24;
  border-radius: 30px;
  /* background: linear-gradient(180deg, #ED1B24 0%, #870F15 100%); */
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  /* box-shadow: 0 4px 12px rgba(237, 27, 36, 0.3); */
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Trust section */
.trust-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 36px;
  align-items: center;
}

.eyebrow {
  color: var(--muted);
  font-weight: 400;
  font-size: 22px;
  letter-spacing: .02em;
}

/* Red dot before "People know us" in Trust section */
.trust .eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.trust .eyebrow::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary);
  display: inline-block;
}

.trust h2 {
  margin: 6px 0 14px;
  font-size: 50px;
  line-height: 1.1;
  font-weight: 700;
}

.accent {
  color: #e01d2c;
}

.muted {
  color: var(--muted);
}

.trust-features {
  display: flex;
  gap: 20px;
  margin-top: 28px;
}

.feature {
  display: flex;
  flex-direction: column;
}

.icon {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  color: #3b5bff;
  font-size: 26px;
}

.feature-title {
  font-weight: 700;
}

.feature-desc {
  color: var(--muted);
  font-size: 14px;
}

.trust-media {
  position: relative;
  margin: 0;
}

/* Position the reused stat-box in Trust section like the original badge */
.trust-stat-badge {
  position: absolute;
  left: -35px;
  bottom: 18px;
  transform: scale(0.7);
  transform-origin: bottom left;
}

@media (max-width: 1024px) {
  .trust-stat-badge {
    left: -24px;
    transform: scale(0.65);
  }
}

@media (max-width: 768px) {
  .trust-stat-badge {
    left: -16px;
    transform: scale(0.6);
  }
}

@media (max-width: 480px) {
  .trust-stat-badge {
    left: -10px;
    transform: scale(0.55);
  }
}


.trust-badge {
  position: absolute;
  left: -18px;
  bottom: 18px;
  background: #d71920;
  color: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .15);
}

.trust-badge .years {
  font-size: 44px;
  font-weight: 800;
  line-height: 1;
}

.trust-badge .years span {
  font-size: 28px;
  font-weight: 700;
  margin-left: 4px;
}

.trust-badge .label {
  opacity: .9;
}

/* Services */
.services-head {
  text-align: center;
  margin-bottom: 20px;
}

/* Red dot before "Our Services" like Trust eyebrow */
.services .services-head .eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.services .services-head .eyebrow::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary);
  display: inline-block;
}

/* Red dot before Quick Facts eyebrow, matching Services */
.about-hero~.section#facts .eyebrow,
#facts .eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff;
}

.about-hero~.section#facts .eyebrow::before,
#facts .eyebrow::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary);
  display: inline-block;
}

/* Slight position tweak for Quick Facts heading block */
#facts .facts-head {
  position: relative;
  transform: translate(0px, -50px);
}

@media (min-width: 768px) {
  #facts .facts-head {
    transform: translate(-12px, -14px);
  }
}

.services h2 {
  font-size: 50px;
  font-weight: 700;
  margin: 6px 0 0;
}

.services-list {
  display: grid;
  gap: 10px;
}

.services-item {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
}

.services-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px;
}

.services-item .num {
  color: var(--muted);
  font-weight: 700;
}

.services-item .title {
  font-weight: 700;
}

.services-item .desc {
  color: var(--muted);
  font-size: 16px;
  line-height: 1.55;
  margin: 8px 0 8px 0;
}

@media (min-width: 640px) {
  .services-item .desc {
    font-size: 17px;
    line-height: 1.6;
  }
}

.services-item .pill {
  width: clamp(40px, 5vw, 42px);
  height: clamp(40px, 5vw, 42px);
  border-radius: 0px 10px 10px 0px;
  border: none;
  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);
  color: #fff;
  cursor: pointer;
}

/* Slightly enlarge the arrow icon inside the Services pill */
.services-item .pill svg {
  width: clamp(14px, 2.2vw, 18px);
  height: clamp(14px, 2.2vw, 18px);
  transform: rotate(-45deg);
  transform-origin: center;
  transition: transform .25s ease;
}

.services-item.active .pill svg {
  transform: rotate(0deg);
}

.services-media {
  display: none;
}

.services-item.active .services-media {
  display: block;
}

.services-item.active img {
  width: 100%;
  border-radius: 10px;
  display: block;
}

/* Reserve space and fade images in once loaded to avoid progressive paint artifacts */
.services-media img {
  width: 100%;
  height: auto;
  display: block;
  opacity: 0;
  transition: opacity .25s ease;
  image-rendering: auto;
}

.services-media img.is-loaded {
  opacity: 1;
}

.services-item.active {
  border-color: #f0d2d5;
  box-shadow: 0 6px 18px rgba(227, 27, 35, .12);
}

/* Footer */
.footer {
  color: #fff;
}

.footer-top {
  background: linear-gradient(180deg, #d71920, #8d0b10);
  position: relative;
  overflow: hidden;
  padding: 36px 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px 64px;
  position: relative;
  z-index: 1;
}

.footer-grid h4 {
  margin: 0 0 10px;
  font-weight: 800;
}

.footer-grid a {
  color: #fff;
  text-decoration: none;
  opacity: .95;
}

.footer-grid a:hover {
  text-decoration: underline;
}

.footer-grid ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
}

/* subtle muted label color */
.footer-grid .muted {
  color: rgba(255, 255, 255, 0.85);
  margin: 8px 0 4px;
}

/* emphasize phone numbers */
.footer-grid .contact-phones {
  font-weight: 700;
}

/* large faded brand image behind content */
.footer-watermark {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1400px;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.footer-cta {
  background: #fff;
  color: var(--text);
  border-top: 1px solid rgba(255, 255, 255, .2);
  border-bottom: 1px solid #eee;
}

.footer-cta-inner {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
  align-items: center;
  padding: 14px 0;
}

.footer-cta .cta-text {
  font-weight: 800;
}

.footer-bottom {
  background: #7e0b10;
  padding: 14px 0;
}

.footer-bottom p {
  margin: 0;
}

/* About page styles */
.about-hero {
  position: relative;
  padding: 140px 0 120px;
  color: #fff;
  overflow: hidden;
  background: linear-gradient(135deg, #e31b23, #8d0b10);
}

.about-hero .hero-content {
  max-width: 600px;
}

.about-hero h1 {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 24px;
}

.about-hero p {
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Contact page styles */
.contact-hero {
  padding: 140px 0 120px;
  color: #fff;
  background: linear-gradient(135deg, #e31b23, #8d0b10);
}

.contact-hero .hero-content {
  max-width: 600px;
}

.contact-hero h1 {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 24px;
}

.contact-hero p {
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Responsive Design */
@media (max-width: 920px) {
  .trust-grid {
    grid-template-columns: 1fr;
  }

  .trust-badge {
    left: 12px;
    bottom: 12px;
  }

  .hero {
    padding: 120px 0 96px;
    min-height: 80vh;
  }

  .hero-inner {
    bottom: 80px;
  }

  .hero h1 {
    font-size: 38px;
  }

  .hero-content-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .lead {
    font-size: 20px;
  }

  .btn-primary {
    padding: 14px 28px;
    font-size: 15px;
  }

  .btn-circle {
    width: 44px;
    height: 44px;
    font-size: 16px;
  }
}

@media (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-cta-inner {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 10px;
  }
}

@media (max-width: 768px) {

  .about-hero h1,
  .contact-hero h1 {
    font-size: 2.5rem;
  }
}

/* About Us Page Styles */
.about-hero {
  position: relative;
  padding: 140px 0 120px;
  color: #fff;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.hero-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 600px;
}

.hero-content h1 {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 24px;
}

.hero-content p {
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0 0 32px;
  opacity: 0.9;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  background: var(--primary);
  color: #fff;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background: #c41e3a;
  transform: translateY(-2px);
}

/* About Who We Are */
.about-who-we-are {
  padding: 80px 0;
}

.who-we-are-content {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  align-items: center;
}

.who-we-are-image {
  position: relative;
}

.who-we-are-image img {
  width: 100%;
  height: auto;
  border-radius: 0px;
}

.stats-overlay {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.stat-box {
  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);
  color: #fff;
  padding: 20px;
  border-radius: 0px;
  text-align: center;
  /* make rectangle: height > width */
  width: clamp(160px, 18vw, 213px);
  aspect-ratio: 213 / 279;
  display: grid;
  place-items: center;
}

/* Mobile sizing for experience box */
@media (max-width: 768px) {
  .stat-box {
    width: 120px;
    aspect-ratio: 213 / 279;
    padding: 14px;
  }

  .stat-box h3 {
    font-size: 1.2rem;
  }

  .stat-box p {
    font-size: 0.95rem;
  }

  /* Tame number size on small screens */
  .stat-box .years-num {
    font-size: clamp(1.6em, 8vw, 2em);
  }

  .stat-box .years-plus {
    font-size: clamp(0.9em, 3.8vw, 1.05em);
  }
}

.stat-box h3 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 2px;
}

.stat-box p {
  font-size: 1.15rem;
  line-height: 1.25;
  margin: 0 auto;
  max-width: 140px;
  opacity: 0.9;
}

/* Ensure larger caption in About > Who We Are stats box */
.about-who-we-are .stat-box p {
  font-size: 1.25rem;
}

@media (max-width: 768px) {
  .about-who-we-are .stat-box p {
    font-size: 1.05rem;
  }
}

/* Larger 5 and smaller + */
.stat-box .years-num {
  font-size: 2.8em;
  line-height: 1;
}

.stat-box .years-plus {
  font-size: 1.3em;
  margin-left: 4px;
  vertical-align: top;
}

/* Slightly larger plus sign in About > Who We Are */
.about-who-we-are .stat-box .years-plus {
  font-size: 1.5em;
}

@media (max-width: 768px) {
  .about-who-we-are .stat-box .years-plus {
    font-size: clamp(1.05em, 4.2vw, 1.2em);
  }
}

.who-we-are-text .section-badge {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;
  color: var(--muted);
  margin-bottom: 16px;
}

.badge-dot {
  width: 8px;
  height: 8px;
  background: var(--primary);
  border-radius: 100%;
  display: inline-block;
}

.who-we-are-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 18px;
  color: var(--text);
}

.highlight-red {
  color: #e31b23;
}

.highlight-green {
  color: #28a745;
}

.who-we-are-text p {
  font-size: 1.1rem;
  line-height: 1.7;
  margin: 0 0 16px;
  color: var(--muted);
}

.who-we-are-text p.intro {
  max-width: 720px;
}

.who-we-are-text p.emphasis {
  font-weight: 700;
  color: #111;
}

/* About Timeline */
.about-timeline {
  padding: 0;
  background: #FFF6F6;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overscroll-behavior: contain;
}

.about-timeline.is-pinned {
  position: fixed;
  inset: 0;
  z-index: 10;
}

/* Spacer removed from inside; page will continue naturally after unpin */

/* Ensure pink background wins over .section.alt gray */
.about-timeline.section.alt {
  background: #FFF6F6;
}

.timeline-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

/* Arrange YEAR, line, and year numbers on one line */
.timeline-sidebar {
  display: flex;
  /* align-items: center; */
  gap: 16px;
  /* margin-top: -12px; */
}

.timeline-indicator {
  position: relative;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}

.timeline-start {
  position: static;
  left: auto;
  top: auto;
}

.timeline-line {
  flex: 1 1;
}

.timeline-active-year {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

.timeline-years {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
  width: 100%;
}

.timeline-sidebar .year-item {
  width: auto;
  white-space: nowrap;
  /* text-align: left; */
}

@media (max-width: 768px) {
  .timeline-sidebar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: -8px;
  }

  .timeline-indicator {
    gap: 8px;
  }

  .timeline-years {
    flex-wrap: nowrap;
  }
}

/* Single frame wrapper for Our Story */
.timeline-frame {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  min-height: auto;
  display: block;
}

/* Keep the timeline content visible while we intercept scroll */
/* Removed sticky to let JS locking control the experience */

.timeline-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 16px 0 40px;
  color: var(--text);
}

/* Match section badge style for Our Story header */
.timeline-header .section-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--muted);
}

.timeline-indicator {
  position: relative;
  margin-bottom: 30px;
}



.year-item {
  display: grid;
  grid-template-columns: minmax(48px, max-content) 1fr minmax(60px, max-content);
  align-items: center;
  column-gap: 16px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #ccc;
  cursor: pointer;
  transition: color 0.3s ease;
  white-space: nowrap;
  /* text-align: right; */
  width: 100%;
}

.year-item.active {
  color: var(--text);
}

.timeline-label {
  font-size: 0.8rem;
  color: var(--muted);
  background: transparent;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
}

.year-item.active .timeline-label {
  opacity: 1;
  visibility: visible;
}

.timeline-line {
  width: 100%;
  height: 2px;
  background: var(--primary);
  justify-self: stretch;
  transform: scaleX(0);
  transform-origin: center;
  opacity: 0;
}

.year-item .year-text {
  min-width: 48px;
  font-weight: 700;
  /* text-align: right; */
}

.year-item.active .timeline-line {
  opacity: 1;
}

@media (max-width: 768px) {
  .year-item.active {
    gap: 8px;
  }
}

.timeline-details h3 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 20px;
  color: var(--text);
}

.timeline-details p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--muted);
  margin: 0 0 30px;
}

.timeline-image img {
  width: 100%;
  height: auto;
  border-radius: 12px;
}

/* About Guiding Pillars */
.about-guiding-pillars {
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  min-height: clamp(520px, 80vh, 760px);
}

.about-guiding-pillars::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.about-guiding-pillars .container,
.about-guiding-pillars .pillars-header,
.about-guiding-pillars .pillars-grid {
  position: relative;
  z-index: 1;
}

.pillars-header {
  text-align: center;
  margin-bottom: 60px;
}

.pillars-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 16px 0 0;
  color: #fff;
}

.about-guiding-pillars .section-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff;
  opacity: .9;
}

.pillars-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 40px;
}

.pillar-card {
  position: relative;
  text-align: center;
  padding: 56px 20px 40px;
  background: rgba(17, 17, 17, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(24, 23, 23, 0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pillar-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.35);
}

.pillar-icon {
  width: 80px;
  height: 80px;
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.pillar-icon img {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.pillar-card h3 {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 12px;
  color: #fff;
}

.pillar-card p {
  font-size: 0.9rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

/* About Mission Vision */
.about-mission-vision {
  padding: 80px 0;
  background: #f8f9fa;
}

/* Click affordance for location interactions */
.about-location .world-map,
.about-location .location-info-card {
  cursor: pointer;
}

/* Widen Vision/Mission section specifically */
.about-mission-vision .container {
  max-width: 1680px;
}

.mission-vision-content {
  display: flex;
  gap: 0;
}

.what-drives-us {
  background: #FFCBCD;
  padding: 40px;
  /* border-radius: 12px; */
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 0 0 32%;
  overflow: visible;
}

.what-drives-us h2 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 30px;
  color: var(--text);
}

.truck-illustration {
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: 100%;
  max-width: clamp(360px, 28vw, 500px);
}

.truck-illustration img {
  display: block;
  width: 100%;
  height: auto;
}

.right-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.row {
  display: flex;
  align-items: stretch;
}

.vision-row,
.mission-row {
  align-items: stretch;
}

.vision-image,
.mission-image,
.vision-text,
.mission-text {
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.vision-image,
.mission-image {
  flex: 1 1 50%;
  display: flex;
}

.mission-image img,
.vision-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0px !important;
}

.mission-text,
.vision-text {
  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);
  color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 50%;
  min-height: 240px;
}

.mission-text h3,
.vision-text h3 {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 16px;
}

.mission-text p,
.vision-text p {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* About Team Showcase */
.about-team-showcase {
  padding: 80px 0;
  background: #FFF6F6;
}

.team-showcase-header {
  text-align: center;
  margin-bottom: 60px;
}

.team-showcase-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 16px 0 0;
  color: var(--text);
}

.team-members-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 30px;
}

.team-member-card {
  padding: 30px 20px;
  border-radius: 12px;
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
  box-shadow: none;
  transition: transform 0.3s ease;
}

.team-member-card:hover {
  transform: translateY(-5px);
}

.member-photo {
  width: 100%;
  max-width: 356px;
  aspect-ratio: 1 / 1;
  margin: 0 auto 20px;
  border-radius: 0 60px 60px 0;
  overflow: hidden;
  border: 2px solid var(--primary);
}

.member-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-member-card h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 8px;
  color: var(--text);
}

.team-member-card p {
  font-size: 0.9rem;
  color: var(--muted);
  margin: 0;
}

/* About Location */
.about-location {
  position: relative;
  padding: 80px 0;
  background: transparent;
  overflow: hidden;
}

.about-location .section-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.about-location .section-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(.85);
}

.location-content {
  position: relative;
  z-index: 1;
}

.location-header {
  text-align: center;
  margin-bottom: 60px;
}

.location-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 16px 0 0;
  color: var(--text);
}

.location-map-container {
  position: relative;
  z-index: 1;
  background: transparent;
  border-radius: 12px;
  padding: min(5vw, 48px) 0;
}

.world-map {
  display: grid;
  place-items: center;
}

.world-map img {
  width: min(980px, 90%);
  height: auto;
  display: block;
}

.location-info-card {
  position: absolute;
  left: 42%;
  transform: translateX(-50%);
  bottom: clamp(12px, 2.5vw, 24px);
  display: flex;
  gap: 24px;
  align-items: center;
  background: #fff;
  max-width: 500px;
  min-width: 150px;
  padding: clamp(16px, 2.2vw, 28px);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .12);
}

.location-image {
  width: clamp(96px, 12vw, 140px);
  aspect-ratio: 3 / 2;
  border-radius: 8px;
  overflow: hidden;
}

.location-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.location-details h3 {
  font-size: clamp(1.1rem, 2.2vw, 1.5rem);
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--text);
}

.location-role {
  font-size: clamp(.9rem, 1.8vw, 1rem);
  font-weight: 600;
  color: var(--primary);
  margin: 0 0 12px;
}

.location-description {
  font-size: clamp(.9rem, 1.8vw, 1rem);
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
}

/* Contact Page Styles */
.contact-hero {
  position: relative;
  padding: 140px 0 120px;
  color: #fff;
  overflow: hidden;
}

/* Card */
.card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Contact Info */
.contact-info {
  background: #f8f9fa;
}

.grid {
  display: grid;
  gap: 30px;
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.info-card {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.info-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 20px;
  color: var(--text);
}

.info-card p {
  margin: 0 0 10px;
  color: var(--muted);
}

.info-card a {
  color: var(--primary);
  text-decoration: none;
}

.info-card a:hover {
  text-decoration: underline;
}

.contact-hero::before {
  filter: brightness(0.55);
}

.contact-hero .hero-inner {
  max-width: var(--container);
  position: relative;
}

.contact-hero .hero-cta {
  margin-top: 8px;
  position: absolute;
  right: 14%;
  bottom: -10px;
}

.contact-inquiry .section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 10px;
}

.contact-inquiry h2 {
  font-size: 40px;
  line-height: 1.15;
  margin: 0 0 16px;
}

.inquiry-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.inquiry-visual img {
  width: min(360px, 90%);
  height: auto;
  display: block;
  margin-top: 20px;
}

.inquiry-card {
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.contact-inquiry .contact-form {
  max-width: none;
  margin-top: 20px;
}

.contact-inquiry .row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.contact-inquiry input,
.contact-inquiry textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
}

.contact-inquiry textarea {
  margin-bottom: 20px;
  resize: vertical;
  min-height: 120px;
}

.contact-inquiry .actions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 6px;
}

/* Toast notifications */
.toast-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 20px;
  display: flex;
  justify-content: center;
  z-index: 1000;
  pointer-events: none;
}

.toast-container .toast {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, .18);
  backdrop-filter: blur(6px);
  transform: translateY(-16px);
  opacity: 0;
  transition: transform .25s ease, opacity .25s ease;
  pointer-events: auto;
}

.toast-container.is-visible .toast {
  opacity: 1;
  transform: translateY(0);
}

.toast.success {
  background: linear-gradient(180deg, rgba(30, 142, 62, .96), rgba(20, 109, 46, .96));
}

.toast.error {
  background: linear-gradient(180deg, rgba(208, 23, 31, .96), rgba(117, 13, 19, .96));
}

.toast-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .9);
}

.toast-message {
  font-weight: 600;
  letter-spacing: .2px;
}

.toast-title {
  font-weight: 800;
  letter-spacing: .3px;
}

.btn-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #eee;
  background: #fff;
  color: var(--primary);
  font-weight: 800;
  cursor: pointer;
}

/* Services Core Logistics */
.services-core-logistics {
  background: #FFF6F6;
  min-height: 100vh;
  position: relative;
}

.services-core-logistics .section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 10px;
}

.services-core-logistics h2 {
  font-size: 40px;
  line-height: 1.15;
  margin: 0 0 24px;
  color: var(--text);
  font-weight: 700;
}

.core-logistics-sticky-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  min-height: 100vh;
}

.sticky-left {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0;
}

.scrollable-right {
  padding: 40px 0;
}

.service-showcase-item {
  margin-bottom: 80px;
  position: relative;
}

.service-showcase-item:last-child {
  margin-bottom: 0;
}

.service-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #b31218;
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}

.service-showcase-item h3 {
  font-size: 32px;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 20px;
}

.service-image {
  margin-bottom: 20px;
}

.service-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.service-description {
  color: var(--muted);
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.cta-container {
  margin-top: auto;
}

/* Responsive Design */
@media (max-width: 768px) {
  .core-logistics-sticky-container {
    grid-template-columns: 1fr;
    gap: 40px;
    min-height: auto;
  }

  .sticky-left {
    position: static;
    height: auto;
    padding: 20px 0;
  }

  .scrollable-right {
    padding: 20px 0;
  }

  .services-core-logistics h2 {
    font-size: 32px;
  }

  .service-showcase-item h3 {
    font-size: 28px;
  }

  .service-number {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .service-showcase-item {
    margin-bottom: 60px;
  }
}

/* Services How We Work */
.services-how-we-work {
  background: #fff;
}

.services-how-we-work .section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 10px;
}

.services-how-we-work h2 {
  font-size: 40px;
  line-height: 1.15;
  margin: 0 0 16px;
  color: var(--text);
}

.how-we-work-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.how-we-work-visual {
  margin-top: 20px;
}

.how-we-work-visual img {
  width: 100%;
  height: auto;
  max-width: 400px;
}

.features-accordion {
  max-width: 100%;
}

.feature-item {
  border-bottom: 1px solid #eee;
}

.feature-toggle {
  width: 100%;
  padding: 14px 6px;
  background: transparent;
  border: none;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  text-align: left;
  color: #b31218;
  font-weight: 700;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.feature-toggle:hover {
  color: #8e0e13;
}

.feature-icon {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  background: #ffe6e7;
  color: #b31218;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.feature-toggle:hover .feature-icon {
  background: #ffd1d3;
}

.feature-panel {
  padding: 0 6px 14px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.5;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .how-we-work-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .services-how-we-work h2 {
    font-size: 32px;
  }

  .how-we-work-visual {
    text-align: center;
  }
}

/* Services Industries */
.services-industries {
  background: #fff;
  padding: 80px 0;
}

.industries-header {
  margin-bottom: 60px;
  text-align: center;
}

.services-industries .section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 10px;
  justify-content: center;
}

.services-industries .section-badge .badge-dot {
  background: var(--primary);
  border-radius: 100%;
  width: 8px;
  height: 8px;
  display: inline-block;
}

.services-industries h2 {
  font-size: 40px;
  line-height: 1.15;
  margin: 0;
  color: var(--text);
  font-weight: 700;
}

.industries-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
}

.industry-card {
  display: flex;
  flex-direction: column;
  opacity: 0.7;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform-origin: center;
  will-change: transform;
  position: relative;
  z-index: 1;
}

.industry-card:hover {
  transform: scale(1.05) !important;
  opacity: 1;
  z-index: 2;
}

.industry-image-wrapper {
  position: relative;
  /* width: 100%; */
  /* aspect-ratio: 4 / 3; */
  /* Commented to avoid forcing crop */
  /* border-radius: 12px; */
  /* Images already have correct shape */
  /* overflow: hidden; */
  /* Allow full image to show */
  margin-bottom: 16px;
}

/* .industry-image-wrapper.highlighted {
  border-top: 4px solid var(--primary);
  border-right: 4px solid var(--primary);
  border-radius: 12px;
} */

.industry-image {
  /* width: 100%; */
  /* Let intrinsic size drive layout */
  /* height: 100%; */
  /* object-fit: cover; */
  /* Commented to prevent cropping */
  /* border-radius: 12px; */
  transition: opacity 0.3s ease;
}


.industry-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 12px;
  text-align: center;
}

.industry-description {
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
  text-align: center;
}

@media (max-width: 1400px) {
  .industries-grid {
    gap: 20px;
  }

}

@media (max-width: 1200px) {
  .industries-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .services-industries {
    padding: 60px 0;
  }

  .services-industries h2 {
    font-size: 32px;
  }

  .industries-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .industry-image-wrapper {
    aspect-ratio: 16 / 9;
  }
}

/* Contact FAQ */
.faq-section {
  background: #fff7f7;
}

.faq-section h2 {
  text-align: center;
  margin: 6px 0 20px;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text);
}

.faq-list {
  max-width: 760px;
  margin: 0 auto;
}

.faq-item {
  border-bottom: 1px solid #eee;
}

.faq-toggle {
  width: 100%;
  padding: 14px 6px;
  background: transparent;
  border: none;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  text-align: left;
  color: #b31218;
  font-weight: 700;
  cursor: pointer;
  font-size: 1rem;
}

.faq-icon {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  background: #ffe6e7;
  color: #b31218;
  font-size: 14px;
  font-weight: bold;
}

.faq-panel {
  padding: 0 6px 14px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.5;
}

/* Responsive Design for About Page */
@media (max-width: 1024px) {
  .pillars-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .about-guiding-pillars {
    min-height: clamp(420px, 70vh, 640px);
  }

  .who-we-are-content,
  .timeline-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .mission-vision-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .row {
    flex-direction: column;
  }

  .what-drives-us {
    flex-basis: auto;
    padding: 24px;
    max-width: none;
  }

  .vision-image,
  .mission-image {
    height: auto;
  }

  .truck-illustration {
    position: static;
    margin-top: 12px;
    max-width: 260px;
    margin-left: auto;
    margin-right: auto;
  }

  .pillars-grid,
  .team-members-grid {
    grid-template-columns: 1fr;
  }

  .location-info-card {
    position: static;
    transform: none;
    margin: 16px auto 0;
    flex-direction: column;
    text-align: center;
  }

  .timeline-years {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .year-item {
    white-space: nowrap;
  }
}

/* Client & Partners - Logo Carousel */
.logo-carousel {
  position: relative;
  overflow: hidden;
  margin-top: 24px;
  z-index: 2;
}

.logo-track {
  display: flex;
  align-items: center;
  gap: clamp(36px, 6vw, 80px);
  animation: logo-scroll 60s linear infinite;
  will-change: transform;
  width: max-content;
}

.logo-item img {
  display: block;
  height: clamp(28px, 5vw, 52px);
  width: auto;
  object-fit: contain;
  filter: saturate(0) contrast(1.0) brightness(0.9);
  transition: filter .2s ease;
}

.logo-item img:hover {
  filter: none;
}

@keyframes logo-scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 920px) {
  .inquiry-grid {
    grid-template-columns: 1fr;
  }
}

/* Testimonials */
.testimonials {
  --card-radius: 12px;
  --card-border: #f0e6e6;
  --dot: #bfbfbf;
  --dot-active: #111;
}

.testimonials.alt {
  background: #fff6f6;
}

.testimonials .testi-head {
  text-align: center;
  margin-bottom: 26px;
}

.testimonials .testi-head .eyebrow {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: var(--muted);
}

.testimonials .testi-head .eyebrow::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary);
  display: inline-block;
}

.testimonials h2 {
  font-size: 40px;
  font-weight: 800;
  margin: 8px 0 0;
}

.testimonials .testi-carousel-wrapper {
  position: relative;
  margin-top: 28px;
}

.testimonials .testi-carousel-container {
  overflow: hidden;
  margin: 0 50px;
}

.testimonials .testi-carousel {
  display: flex;
  gap: 24px;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

.testimonials .testi-carousel .testi-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 48px) / 3);
  min-width: 0;
}

.testimonials .carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.testimonials .carousel-btn:hover:not(:disabled) {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(227, 27, 35, 0.3);
}

.testimonials .carousel-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.testimonials .carousel-btn-prev {
  left: 0;
}

.testimonials .carousel-btn-next {
  right: 0;
}

.testimonials .carousel-btn svg {
  width: 20px;
  height: 20px;
  color: currentColor;
}

.testimonials .testi-card {
  background: #fff;
  border: 1px solid var(--card-border);
  border-radius: var(--card-radius);
  padding: 26px 22px 22px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .03);
}

.testimonials .testi-card .quote {
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 1.7;
  color: #111;
}

.testimonials .byline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.testimonials .byline img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.testimonials .person .name {
  font-weight: 700;
}

.testimonials .person .role {
  color: var(--muted);
}

.testimonials .byline .bubble {
  margin-left: auto;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #ffe6e7;
  color: #d71920;
  font-size: 18px;
}

.testimonials .dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.testimonials .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--dot);
  border: none;
  padding: 0;
  cursor: pointer;
}

.testimonials .dot.is-active {
  width: 7px;
  height: 7px;
  background: var(--dot-active);
}

@media (max-width: 1024px) {
  .testimonials .testi-carousel .testi-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% - 24px) / 2);
  }

  .testimonials .testi-carousel-container {
    margin: 0 50px;
  }
}

@media (max-width: 768px) {
  .testimonials .testi-carousel .testi-card {
    flex: 0 0 100%;
  }

  .testimonials .testi-carousel-container {
    margin: 0 40px;
  }

  .testimonials .carousel-btn {
    width: 36px;
    height: 36px;
  }

  .testimonials .carousel-btn svg {
    width: 16px;
    height: 16px;
  }
}

/* Scroll animations */
.scroll-animate {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.scroll-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.scroll-animate-left {
  opacity: 0;
  transform: translateX(-30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.scroll-animate-left.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.scroll-animate-right {
  opacity: 0;
  transform: translateX(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.scroll-animate-right.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.scroll-animate-scale {
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.scroll-animate-scale.animate-in {
  opacity: 1;
  transform: scale(1);
}

/* Staggered animations for multiple elements */
.scroll-animate-stagger {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.scroll-animate-stagger.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.scroll-animate-stagger:nth-child(1) {
  transition-delay: 0.1s;
}

.scroll-animate-stagger:nth-child(2) {
  transition-delay: 0.2s;
}

.scroll-animate-stagger:nth-child(3) {
  transition-delay: 0.3s;
}

.scroll-animate-stagger:nth-child(4) {
  transition-delay: 0.4s;
}

.scroll-animate-stagger:nth-child(5) {
  transition-delay: 0.5s;
}

.scroll-animate-stagger:nth-child(6) {
  transition-delay: 0.6s;
}

/* Counter animation */
.counter-animate {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.counter-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Parallax effect */
.parallax-slow {
  transform: translateY(0);
  transition: transform 0.1s ease-out;
}

/* Hover animations */
.hover-lift {
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
}

.hover-lift:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.hover-scale {
  transition: transform 0.3s ease-out;
}

.hover-scale:hover {
  transform: scale(1.05);
}

/* Fade in with blur effect */
.scroll-animate-blur {
  opacity: 0;
  filter: blur(10px);
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, filter 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-animate-blur.animate-in {
  opacity: 1;
  filter: blur(0);
  transform: translateY(0);
}

/* Animated word reveal helpers */
.word-mask {
  display: inline-block;
  overflow: hidden;
}

.word {
  display: inline-block;
}

.animated-line {
  display: block;
}

/* Scroll to Top Button */
.scroll-to-top {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease, background-color 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scroll-to-top:hover {
  background: #c4161d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.scroll-to-top:active {
  transform: translateY(0);
}

.scroll-to-top.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.scroll-to-top svg {
  width: 20px;
  height: 20px;
}

@media (max-width: 768px) {
  .scroll-to-top {
    width: 44px;
    height: 44px;
    bottom: 20px;
    right: 20px;
  }

  .scroll-to-top svg {
    width: 18px;
    height: 18px;
  }
}

.hover\\:h-2:hover {
  height: 0.5rem;
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px) {

  .sm\\:ml-6 {
    margin-left: 1.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .sm\\:w-\\[90px\\] {
    width: 90px;
  }

  .sm\\:max-w-\\[34\\%\\] {
    max-width: 34%;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:self-start {
    align-self: flex-start;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px) {

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:h-28 {
    height: 7rem;
  }

  .md\\:w-28 {
    width: 7rem;
  }

  .md\\:w-\\[108px\\] {
    width: 108px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:max-w-none {
    max-width: none;
  }

  .md\\:flex-1 {
    flex: 1 1;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:place-items-start {
    place-items: start;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:\\!text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .lg\\:w-\\[450px\\] {
    width: 450px;
  }

  .lg\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .lg\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-\\[79px\\] {
    font-size: 79px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAInB,gEAAgE;;AAEhE;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,mEAAmE;EACnE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,SAAS;IACT,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,WAAW;IACX,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,sBAAsB;EACtB,mEAAmE;EACnE,4BAA4B;EAC5B,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAO;EACP,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,2DAA2D;AAC3D;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;AAChC;;;AAGA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;;AAGF;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,mDAAmD;EACnD,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mEAAmE;EACnE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mDAAmD;EACnD,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sFAAsF;AACtF;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;EACX;AACF;;AAEA;;EAEE;;IAEE,iBAAiB;EACnB;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA,yEAAyE;;AAEzE,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gEAAgE;AAChE,4DAA4D;;AAE5D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,8EAA8E;EAC9E,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;;EAEE,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,4BAA4B;EAC5B,UAAU;EACV,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kDAAkD;EAClD,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,sCAAsC;EACtC,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,oGAAoG;EACpG,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AA3rGA;EAAA;AA2rGC;;AA3rGD;EAAA,iBA2rGC;EA3rGD,iBA2rGC;EA3rGD;AA2rGC;;AA3rGD;EAAA,kBA2rGC;EA3rGD;AA2rGC;;AA3rGD;EAAA,oBA2rGC;EA3rGD;AA2rGC;;AA3rGD;EAAA,gFA2rGC;EA3rGD,oGA2rGC;EA3rGD;AA2rGC;;AA3rGD;;EAAA;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,mBA2rGC;IA3rGD;EA2rGC;AAAA;;AA3rGD;;EAAA;IAAA,gBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,kBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,8BA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,iBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,mBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,eA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,kBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,eA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,mBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,kBA2rGC;IA3rGD;EA2rGC;AAAA;;AA3rGD;;EAAA;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,iBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,mBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,kBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,eA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,iBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA;EA2rGC;;EA3rGD;IAAA,eA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,mBA2rGC;IA3rGD;EA2rGC;;EA3rGD;IAAA,kBA2rGC;IA3rGD;EA2rGC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');\n\n/* Avenir Font Family - Using system fonts as fallback for now */\n\n:root {\n  --container: 1440px;\n  --text: #0e0e0e;\n  --muted: #5b5b5b;\n  --bg: #ffffff;\n  --primary: #e31b23;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;\n  color: var(--text);\n  background: var(--bg);\n  overflow-x: hidden;\n  /* prevent mobile horizontal slider */\n  scroll-behavior: smooth;\n}\n\n#root {\n  min-height: 100dvh;\n}\n\n.container {\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n/* Header */\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: saturate(180%) blur(10px);\n  border-bottom: 1px solid #eee;\n  margin: 0 auto;\n}\n\n.header-inner {\n  display: flex;\n  max-width: 1520px;\n  margin: 0 auto;\n  align-items: center;\n  gap: 24px;\n  padding: 7px 16px;\n  position: relative;\n}\n\n.nav-toggle {\n  margin-left: auto;\n  display: none;\n  width: 42px;\n  height: 42px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  background: #fff;\n  cursor: pointer;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 0;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.nav-toggle:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n.nav-toggle .nav-toggle-bar {\n  display: block;\n  width: 20px;\n  height: 2px;\n  background: #111;\n  position: relative;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.nav-toggle .nav-toggle-bar:nth-child(2) {\n  margin: 0;\n}\n\n/* Hamburger to X animation when menu is open */\n.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(2) {\n  opacity: 0;\n  transform: scaleX(0);\n}\n\n.site-header.is-open .nav-toggle .nav-toggle-bar:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.brand img {\n  display: block;\n  width: clamp(100px, 18vw, 247px);\n  height: auto;\n  max-height: 70px;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .site-header .container {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-left: 5%;\n}\n\n.main-nav {\n  display: flex;\n  gap: 80px;\n  flex-grow: 2;\n}\n\n.main-nav a {\n  white-space: nowrap;\n  color: var(--text);\n  text-decoration: none;\n  font-weight: 600;\n  position: relative;\n  padding-bottom: 8px;\n}\n\n.main-nav a:hover {\n  color: var(--primary);\n}\n\n.main-nav a.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: var(--primary);\n  border-radius: 2px;\n}\n\n.search {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  justify-self: flex-end;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-radius: 999px;\n  padding: 2px;\n  background: #fff;\n  transition: box-shadow .2s ease;\n}\n\n.search:focus-within {\n  box-shadow: 0 0 0 3px rgba(227, 27, 35, .12);\n}\n\n.search input {\n  padding: 8px 12px;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  width: 120px;\n  transition: width .25s ease;\n}\n\n.search-btn {\n  display: inline-grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #8c8c8c;\n  cursor: pointer;\n}\n\n.search-btn:hover {\n  color: #555;\n}\n\n.search:focus-within input {\n  width: 200px;\n}\n\n/* Mobile nav behavior */\n@media (max-width: 800px) {\n  .site-header {\n    overflow: visible;\n  }\n\n  .nav-toggle {\n    display: inline-flex;\n    margin-left: auto;\n    order: 3;\n  }\n\n  .header-inner {\n    position: relative;\n    justify-content: space-between;\n    padding: 7px 16px;\n    overflow: visible;\n  }\n\n  .brand {\n    order: 1;\n    flex-shrink: 0;\n  }\n\n  .header-right {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    width: 100%;\n    z-index: 1001;\n    margin: 0;\n    padding: 0;\n    margin-left: calc(50% - 50vw);\n    margin-right: calc(50% - 50vw);\n    padding-left: calc(50vw - 50%);\n    padding-right: calc(50vw - 50%);\n  }\n\n  .search {\n    display: none;\n  }\n\n  .main-nav {\n    position: relative;\n    display: grid;\n    gap: 0;\n    background: #fff;\n    border-bottom: 1px solid #eee;\n    transform-origin: top;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .site-header.is-open .main-nav {\n    max-height: 400px;\n  }\n\n  .main-nav a {\n    padding: 14px 24px;\n    border-top: 1px solid #f2f2f2;\n    display: block;\n    width: 100%;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  .main-nav a:first-child {\n    border-top: none;\n  }\n}\n\n/* Desktop spacing */\n@media (min-width: 801px) {\n  .header-inner {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .main-nav {\n    margin: 0;\n    justify-self: center;\n  }\n\n  .search {\n    justify-self: end;\n  }\n}\n\n/* Hero */\n.hero {\n  position: relative;\n  padding: 140px 0 120px;\n  color: #fff;\n  min-height: 100vh;\n}\n\n.hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image: var(--hero-bg);\n  background-size: cover;\n  background-position: center calc(50% + var(--parallax-offset, 0px));\n  background-repeat: no-repeat;\n  z-index: 0;\n  will-change: background-position;\n}\n\n.hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n}\n\n.hero-inner {\n  position: relative;\n  height: 70vh;\n  /* full viewport height */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  /* this moves content to the bottom */\n  /* keeps it left-aligned */\n  z-index: 2;\n  width: 100%;\n  padding-bottom: 4rem;\n  /* add some space from the bottom */\n}\n\n.hero h1 {\n  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;\n  font-weight: 900;\n  font-style: normal;\n  font-size: 79px;\n  line-height: 100%;\n  letter-spacing: 0;\n  margin: 0 0 16px;\n  /* Constrain heading width for consistent wrapping across pages */\n  max-width: 900px;\n}\n\n.lead {\n  color: #f0f0f0;\n  margin: 0;\n  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  flex: 1;\n  /* Constrain body copy width so CTA alignment matches home */\n  max-width: 560px;\n}\n\n.hero-content-row {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  margin-top: 16px;\n}\n\n.hero-cta {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.hero-cta:hover .btn-primary,\n.hero-cta:hover .btn-circle {\n  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);\n}\n\n.hero-cta:hover .btn-circle {\n  transform: translateX(6px);\n}\n\n\n/* Prevent CTA text wrapping in hero */\n.hero-cta .btn-primary {\n  white-space: nowrap;\n  border-radius: 30px 10px 10px 30px !important;\n  height: clamp(48px, 7vw, 56px);\n  padding: 12px clamp(24px, 4.2vw, 36px);\n}\n\n/* Make the arrow button a rounded square in the hero CTA */\n.hero-cta .btn-circle {\n  border-radius: 0px 10px 10px 0px !important;\n  /* border-radius: 8px; */\n  width: clamp(48px, 7vw, 56px);\n  height: clamp(48px, 7vw, 56px);\n}\n\n\n/* Sections */\n.section {\n  padding: 80px 0;\n}\n\n.section.alt {\n  background: #f8f9fb;\n}\n\n.section h2 {\n  font-size: 32px;\n  margin: 0 0 24px;\n}\n\n/* Services Core Logistics - 100vh split layout with pinned left */\n.services-core-logistics {\n  padding: 0;\n}\n\n.core-logistics-sticky-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: stretch;\n  min-height: 100vh;\n}\n\n.core-logistics-left {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 80px 24px;\n}\n\n.core-logistics-right {\n  position: relative;\n  padding: 80px 24px;\n}\n\n.service-showcase-item {\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.service-showcase-item .service-image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n@media (min-width: 1024px) {\n  .core-logistics-left {\n    padding: 120px 48px;\n  }\n\n  .core-logistics-right {\n    padding: 120px 48px;\n  }\n}\n\n/* Accordions (keep bg #FFF6F6 only) */\n.accordion {\n  margin-top: 16px;\n}\n\n.accordion-item {\n  background: #FFF6F6;\n  border: none;\n  border-radius: 12px;\n  margin: 12px 0;\n  overflow: hidden;\n  transition: background-color .2s ease;\n}\n\n.accordion-item.is-open {\n  background: #FFCBCD;\n}\n\n.accordion-header {\n  width: 100%;\n  text-align: left;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #FFF6F6;\n  border: none;\n  cursor: pointer;\n}\n\n.accordion-item.is-open .accordion-header {\n  background: #FFCBCD;\n}\n\n.accordion-header .acc-bullet {\n  width: 8px;\n  height: 8px;\n  background: #E31B23;\n  border-radius: 50%;\n}\n\n.accordion-header .acc-label {\n  color: #E31B23;\n  font-weight: 700;\n}\n\n.acc-toggle {\n  display: inline-flex;\n  transition: transform .2s ease;\n}\n\n.acc-toggle.rot-180 {\n  transform: rotate(180deg);\n}\n\n.accordion-content {\n  background: #FFF6F6;\n  transition: max-height .25s ease;\n}\n\n.accordion-item.is-open .accordion-content {\n  background: #FFCBCD;\n}\n\n.accordion-content-inner {\n  padding: 0 16px 14px 36px;\n  color: #5b5b5b;\n}\n\n\n.rec-card {\n  background: #FFCBCD;\n  gap: 24px;\n  width: 100%;\n  position: relative;\n  margin: 15% 0 15% 0;\n  padding: 8% 6%;\n  border-radius: 16px;\n}\n\n/* subtle world map watermark */\n.rec-card .rec-bg {\n  position: absolute;\n  inset: 0;\n  border-radius: 16px;\n  background-size: cover;\n  background-position: center;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.rec-copy {\n  position: relative;\n  z-index: 2;\n}\n\n.rec-copy h2 {\n  font-size: clamp(28px, 3.6vw, 48px);\n  line-height: 1.1;\n  margin: 0 0 12px;\n  font-weight: 700;\n}\n\n.rec-copy .accent {\n  color: var(--primary);\n}\n\n.rec-copy .muted {\n  color: var(--muted);\n  margin: 0 0 20px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.rec-actions {\n  display: inline-flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* contact button and arrow pair styling */\n.btn.btn-outline {\n  border-color: #e5a5aa;\n  color: #111;\n  background: #fff;\n}\n\n.rec-actions .btn-circle {\n  width: 46px;\n  height: 46px;\n  background: #fff;\n  color: #e01d2c;\n}\n\n.rec-actions .btn-outline:hover,\n.rec-actions .btn-circle:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 24px rgba(227, 27, 35, .18);\n}\n\n/* colored bars behind the person image */\n.flag-bars {\n  position: absolute;\n  right: 10%;\n  bottom: 15%;\n  width: clamp(180px, 22vw, 420px);\n  display: grid;\n  gap: 6px;\n  z-index: 0;\n}\n\n.flag-bars .bar {\n  height: clamp(46px, 6vw, 68px);\n  border-radius: 0;\n}\n\n.flag-bars .bar-red {\n  background: #e01d2c;\n}\n\n.flag-bars .bar-blue {\n  background: #1938a5;\n}\n\n.flag-bars .bar-green {\n  background: #1a8f3a;\n}\n\n\n.rec-media {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 50%;\n  max-width: 689px;\n  z-index: 1;\n}\n\n.rec-media img {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: auto;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n@media (max-width: 900px) {\n  .rec-card {\n    grid-template-columns: 1fr;\n    text-align: left;\n  }\n\n  .rec-media img {\n    margin: 0 auto;\n  }\n\n\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 18px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  text-decoration: none;\n  font-family: 'Avenir', system-ui, Helvetica, Arial, sans-serif;\n  font-weight: 600;\n}\n\n.btn-primary {\n  /* background: linear-gradient(180deg, #ED1B24 0%, #870F15 100%); */\n  color: #fff;\n  padding: 12px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  border: 1px solid #ED1B24;\n  border-radius: 30px !important;\n  /* box-shadow: 0 4px 12px rgba(237, 27, 36, 0.3); */\n  transition: all 0.3s ease;\n  height: 48px;\n  display: flex;\n  align-items: center;\n}\n\n\n\n.btn-circle {\n  width: 48px;\n  height: 48px;\n  border: 1px solid #ED1B24;\n  border-radius: 30px;\n  /* background: linear-gradient(180deg, #ED1B24 0%, #870F15 100%); */\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  /* box-shadow: 0 4px 12px rgba(237, 27, 36, 0.3); */\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n/* Trust section */\n.trust-grid {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 36px;\n  align-items: center;\n}\n\n.eyebrow {\n  color: var(--muted);\n  font-weight: 400;\n  font-size: 22px;\n  letter-spacing: .02em;\n}\n\n/* Red dot before \"People know us\" in Trust section */\n.trust .eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.trust .eyebrow::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--primary);\n  display: inline-block;\n}\n\n.trust h2 {\n  margin: 6px 0 14px;\n  font-size: 50px;\n  line-height: 1.1;\n  font-weight: 700;\n}\n\n.accent {\n  color: #e01d2c;\n}\n\n.muted {\n  color: var(--muted);\n}\n\n.trust-features {\n  display: flex;\n  gap: 20px;\n  margin-top: 28px;\n}\n\n.feature {\n  display: flex;\n  flex-direction: column;\n}\n\n.icon {\n  width: 48px;\n  height: 48px;\n  display: grid;\n  place-items: center;\n  color: #3b5bff;\n  font-size: 26px;\n}\n\n.feature-title {\n  font-weight: 700;\n}\n\n.feature-desc {\n  color: var(--muted);\n  font-size: 14px;\n}\n\n.trust-media {\n  position: relative;\n  margin: 0;\n}\n\n/* Position the reused stat-box in Trust section like the original badge */\n.trust-stat-badge {\n  position: absolute;\n  left: -35px;\n  bottom: 18px;\n  transform: scale(0.7);\n  transform-origin: bottom left;\n}\n\n@media (max-width: 1024px) {\n  .trust-stat-badge {\n    left: -24px;\n    transform: scale(0.65);\n  }\n}\n\n@media (max-width: 768px) {\n  .trust-stat-badge {\n    left: -16px;\n    transform: scale(0.6);\n  }\n}\n\n@media (max-width: 480px) {\n  .trust-stat-badge {\n    left: -10px;\n    transform: scale(0.55);\n  }\n}\n\n\n.trust-badge {\n  position: absolute;\n  left: -18px;\n  bottom: 18px;\n  background: #d71920;\n  color: #fff;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .15);\n}\n\n.trust-badge .years {\n  font-size: 44px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.trust-badge .years span {\n  font-size: 28px;\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n.trust-badge .label {\n  opacity: .9;\n}\n\n/* Services */\n.services-head {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n/* Red dot before \"Our Services\" like Trust eyebrow */\n.services .services-head .eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.services .services-head .eyebrow::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--primary);\n  display: inline-block;\n}\n\n/* Red dot before Quick Facts eyebrow, matching Services */\n.about-hero~.section#facts .eyebrow,\n#facts .eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n}\n\n.about-hero~.section#facts .eyebrow::before,\n#facts .eyebrow::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--primary);\n  display: inline-block;\n}\n\n/* Slight position tweak for Quick Facts heading block */\n#facts .facts-head {\n  position: relative;\n  transform: translate(0px, -50px);\n}\n\n@media (min-width: 768px) {\n  #facts .facts-head {\n    transform: translate(-12px, -14px);\n  }\n}\n\n.services h2 {\n  font-size: 50px;\n  font-weight: 700;\n  margin: 6px 0 0;\n}\n\n.services-list {\n  display: grid;\n  gap: 10px;\n}\n\n.services-item {\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 14px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.services-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 18px;\n}\n\n.services-item .num {\n  color: var(--muted);\n  font-weight: 700;\n}\n\n.services-item .title {\n  font-weight: 700;\n}\n\n.services-item .desc {\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1.55;\n  margin: 8px 0 8px 0;\n}\n\n@media (min-width: 640px) {\n  .services-item .desc {\n    font-size: 17px;\n    line-height: 1.6;\n  }\n}\n\n.services-item .pill {\n  width: clamp(40px, 5vw, 42px);\n  height: clamp(40px, 5vw, 42px);\n  border-radius: 0px 10px 10px 0px;\n  border: none;\n  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);\n  color: #fff;\n  cursor: pointer;\n}\n\n/* Slightly enlarge the arrow icon inside the Services pill */\n.services-item .pill svg {\n  width: clamp(14px, 2.2vw, 18px);\n  height: clamp(14px, 2.2vw, 18px);\n  transform: rotate(-45deg);\n  transform-origin: center;\n  transition: transform .25s ease;\n}\n\n.services-item.active .pill svg {\n  transform: rotate(0deg);\n}\n\n.services-media {\n  display: none;\n}\n\n.services-item.active .services-media {\n  display: block;\n}\n\n.services-item.active img {\n  width: 100%;\n  border-radius: 10px;\n  display: block;\n}\n\n/* Reserve space and fade images in once loaded to avoid progressive paint artifacts */\n.services-media img {\n  width: 100%;\n  height: auto;\n  display: block;\n  opacity: 0;\n  transition: opacity .25s ease;\n  image-rendering: auto;\n}\n\n.services-media img.is-loaded {\n  opacity: 1;\n}\n\n.services-item.active {\n  border-color: #f0d2d5;\n  box-shadow: 0 6px 18px rgba(227, 27, 35, .12);\n}\n\n/* Footer */\n.footer {\n  color: #fff;\n}\n\n.footer-top {\n  background: linear-gradient(180deg, #d71920, #8d0b10);\n  position: relative;\n  overflow: hidden;\n  padding: 36px 0;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 28px 64px;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-grid h4 {\n  margin: 0 0 10px;\n  font-weight: 800;\n}\n\n.footer-grid a {\n  color: #fff;\n  text-decoration: none;\n  opacity: .95;\n}\n\n.footer-grid a:hover {\n  text-decoration: underline;\n}\n\n.footer-grid ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 8px;\n}\n\n/* subtle muted label color */\n.footer-grid .muted {\n  color: rgba(255, 255, 255, 0.85);\n  margin: 8px 0 4px;\n}\n\n/* emphasize phone numbers */\n.footer-grid .contact-phones {\n  font-weight: 700;\n}\n\n/* large faded brand image behind content */\n.footer-watermark {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 1400px;\n  pointer-events: none;\n  user-select: none;\n}\n\n.footer-cta {\n  background: #fff;\n  color: var(--text);\n  border-top: 1px solid rgba(255, 255, 255, .2);\n  border-bottom: 1px solid #eee;\n}\n\n.footer-cta-inner {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 16px;\n  align-items: center;\n  padding: 14px 0;\n}\n\n.footer-cta .cta-text {\n  font-weight: 800;\n}\n\n.footer-bottom {\n  background: #7e0b10;\n  padding: 14px 0;\n}\n\n.footer-bottom p {\n  margin: 0;\n}\n\n/* About page styles */\n.about-hero {\n  position: relative;\n  padding: 140px 0 120px;\n  color: #fff;\n  overflow: hidden;\n  background: linear-gradient(135deg, #e31b23, #8d0b10);\n}\n\n.about-hero .hero-content {\n  max-width: 600px;\n}\n\n.about-hero h1 {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 24px;\n}\n\n.about-hero p {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* Contact page styles */\n.contact-hero {\n  padding: 140px 0 120px;\n  color: #fff;\n  background: linear-gradient(135deg, #e31b23, #8d0b10);\n}\n\n.contact-hero .hero-content {\n  max-width: 600px;\n}\n\n.contact-hero h1 {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 24px;\n}\n\n.contact-hero p {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* Responsive Design */\n@media (max-width: 920px) {\n  .trust-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .trust-badge {\n    left: 12px;\n    bottom: 12px;\n  }\n\n  .hero {\n    padding: 120px 0 96px;\n    min-height: 80vh;\n  }\n\n  .hero-inner {\n    bottom: 80px;\n  }\n\n  .hero h1 {\n    font-size: 38px;\n  }\n\n  .hero-content-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n\n  .lead {\n    font-size: 20px;\n  }\n\n  .btn-primary {\n    padding: 14px 28px;\n    font-size: 15px;\n  }\n\n  .btn-circle {\n    width: 44px;\n    height: 44px;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 900px) {\n  .footer-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-cta-inner {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .about-hero h1,\n  .contact-hero h1 {\n    font-size: 2.5rem;\n  }\n}\n\n/* About Us Page Styles */\n.about-hero {\n  position: relative;\n  padding: 140px 0 120px;\n  color: #fff;\n  overflow: hidden;\n}\n\n.hero-background {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.hero-background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 600px;\n}\n\n.hero-content h1 {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 24px;\n}\n\n.hero-content p {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  margin: 0 0 32px;\n  opacity: 0.9;\n}\n\n.cta-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 32px;\n  background: var(--primary);\n  color: #fff;\n  text-decoration: none;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.cta-button:hover {\n  background: #c41e3a;\n  transform: translateY(-2px);\n}\n\n/* About Who We Are */\n.about-who-we-are {\n  padding: 80px 0;\n}\n\n.who-we-are-content {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.who-we-are-image {\n  position: relative;\n}\n\n.who-we-are-image img {\n  width: 100%;\n  height: auto;\n  border-radius: 0px;\n}\n\n.stats-overlay {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n\n.stat-box {\n  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);\n  color: #fff;\n  padding: 20px;\n  border-radius: 0px;\n  text-align: center;\n  /* make rectangle: height > width */\n  width: clamp(160px, 18vw, 213px);\n  aspect-ratio: 213 / 279;\n  display: grid;\n  place-items: center;\n}\n\n/* Mobile sizing for experience box */\n@media (max-width: 768px) {\n  .stat-box {\n    width: 120px;\n    aspect-ratio: 213 / 279;\n    padding: 14px;\n  }\n\n  .stat-box h3 {\n    font-size: 1.2rem;\n  }\n\n  .stat-box p {\n    font-size: 0.95rem;\n  }\n\n  /* Tame number size on small screens */\n  .stat-box .years-num {\n    font-size: clamp(1.6em, 8vw, 2em);\n  }\n\n  .stat-box .years-plus {\n    font-size: clamp(0.9em, 3.8vw, 1.05em);\n  }\n}\n\n.stat-box h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 2px;\n}\n\n.stat-box p {\n  font-size: 1.15rem;\n  line-height: 1.25;\n  margin: 0 auto;\n  max-width: 140px;\n  opacity: 0.9;\n}\n\n/* Ensure larger caption in About > Who We Are stats box */\n.about-who-we-are .stat-box p {\n  font-size: 1.25rem;\n}\n\n@media (max-width: 768px) {\n  .about-who-we-are .stat-box p {\n    font-size: 1.05rem;\n  }\n}\n\n/* Larger 5 and smaller + */\n.stat-box .years-num {\n  font-size: 2.8em;\n  line-height: 1;\n}\n\n.stat-box .years-plus {\n  font-size: 1.3em;\n  margin-left: 4px;\n  vertical-align: top;\n}\n\n/* Slightly larger plus sign in About > Who We Are */\n.about-who-we-are .stat-box .years-plus {\n  font-size: 1.5em;\n}\n\n@media (max-width: 768px) {\n  .about-who-we-are .stat-box .years-plus {\n    font-size: clamp(1.05em, 4.2vw, 1.2em);\n  }\n}\n\n.who-we-are-text .section-badge {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 0.9rem;\n  color: var(--muted);\n  margin-bottom: 16px;\n}\n\n.badge-dot {\n  width: 8px;\n  height: 8px;\n  background: var(--primary);\n  border-radius: 100%;\n  display: inline-block;\n}\n\n.who-we-are-text h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 18px;\n  color: var(--text);\n}\n\n.highlight-red {\n  color: #e31b23;\n}\n\n.highlight-green {\n  color: #28a745;\n}\n\n.who-we-are-text p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  margin: 0 0 16px;\n  color: var(--muted);\n}\n\n.who-we-are-text p.intro {\n  max-width: 720px;\n}\n\n.who-we-are-text p.emphasis {\n  font-weight: 700;\n  color: #111;\n}\n\n/* About Timeline */\n.about-timeline {\n  padding: 0;\n  background: #FFF6F6;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  overscroll-behavior: contain;\n}\n\n.about-timeline.is-pinned {\n  position: fixed;\n  inset: 0;\n  z-index: 10;\n}\n\n/* Spacer removed from inside; page will continue naturally after unpin */\n\n/* Ensure pink background wins over .section.alt gray */\n.about-timeline.section.alt {\n  background: #FFF6F6;\n}\n\n.timeline-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n}\n\n/* Arrange YEAR, line, and year numbers on one line */\n.timeline-sidebar {\n  display: flex;\n  /* align-items: center; */\n  gap: 16px;\n  /* margin-top: -12px; */\n}\n\n.timeline-indicator {\n  position: relative;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.timeline-start {\n  position: static;\n  left: auto;\n  top: auto;\n}\n\n.timeline-line {\n  flex: 1;\n}\n\n.timeline-active-year {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.timeline-years {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.timeline-sidebar .year-item {\n  width: auto;\n  white-space: nowrap;\n  /* text-align: left; */\n}\n\n@media (max-width: 768px) {\n  .timeline-sidebar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-top: -8px;\n  }\n\n  .timeline-indicator {\n    gap: 8px;\n  }\n\n  .timeline-years {\n    flex-wrap: nowrap;\n  }\n}\n\n/* Single frame wrapper for Our Story */\n.timeline-frame {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n  min-height: auto;\n  display: block;\n}\n\n/* Keep the timeline content visible while we intercept scroll */\n/* Removed sticky to let JS locking control the experience */\n\n.timeline-header h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 16px 0 40px;\n  color: var(--text);\n}\n\n/* Match section badge style for Our Story header */\n.timeline-header .section-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n.timeline-indicator {\n  position: relative;\n  margin-bottom: 30px;\n}\n\n\n\n.year-item {\n  display: grid;\n  grid-template-columns: minmax(48px, max-content) 1fr minmax(60px, max-content);\n  align-items: center;\n  column-gap: 16px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #ccc;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  white-space: nowrap;\n  /* text-align: right; */\n  width: 100%;\n}\n\n.year-item.active {\n  color: var(--text);\n}\n\n.timeline-label {\n  font-size: 0.8rem;\n  color: var(--muted);\n  background: transparent;\n  padding: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease;\n}\n\n.year-item.active .timeline-label {\n  opacity: 1;\n  visibility: visible;\n}\n\n.timeline-line {\n  width: 100%;\n  height: 2px;\n  background: var(--primary);\n  justify-self: stretch;\n  transform: scaleX(0);\n  transform-origin: center;\n  opacity: 0;\n}\n\n.year-item .year-text {\n  min-width: 48px;\n  font-weight: 700;\n  /* text-align: right; */\n}\n\n.year-item.active .timeline-line {\n  opacity: 1;\n}\n\n@media (max-width: 768px) {\n  .year-item.active {\n    gap: 8px;\n  }\n}\n\n.timeline-details h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 20px;\n  color: var(--text);\n}\n\n.timeline-details p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: var(--muted);\n  margin: 0 0 30px;\n}\n\n.timeline-image img {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n}\n\n/* About Guiding Pillars */\n.about-guiding-pillars {\n  padding: 80px 0;\n  position: relative;\n  overflow: hidden;\n  min-height: clamp(520px, 80vh, 760px);\n}\n\n.about-guiding-pillars::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.about-guiding-pillars .container,\n.about-guiding-pillars .pillars-header,\n.about-guiding-pillars .pillars-grid {\n  position: relative;\n  z-index: 1;\n}\n\n.pillars-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.pillars-header h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 16px 0 0;\n  color: #fff;\n}\n\n.about-guiding-pillars .section-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #fff;\n  opacity: .9;\n}\n\n.pillars-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 40px;\n}\n\n.pillar-card {\n  position: relative;\n  text-align: center;\n  padding: 56px 20px 40px;\n  background: rgba(17, 17, 17, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(24, 23, 23, 0.25);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.pillar-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.35);\n}\n\n.pillar-icon {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.pillar-icon img {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n}\n\n.pillar-card h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  margin: 0 0 12px;\n  color: #fff;\n}\n\n.pillar-card p {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0;\n}\n\n/* About Mission Vision */\n.about-mission-vision {\n  padding: 80px 0;\n  background: #f8f9fa;\n}\n\n/* Click affordance for location interactions */\n.about-location .world-map,\n.about-location .location-info-card {\n  cursor: pointer;\n}\n\n/* Widen Vision/Mission section specifically */\n.about-mission-vision .container {\n  max-width: 1680px;\n}\n\n.mission-vision-content {\n  display: flex;\n  gap: 0;\n}\n\n.what-drives-us {\n  background: #FFCBCD;\n  padding: 40px;\n  /* border-radius: 12px; */\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  flex: 0 0 32%;\n  overflow: visible;\n}\n\n.what-drives-us h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 30px;\n  color: var(--text);\n}\n\n.truck-illustration {\n  position: absolute;\n  right: 12px;\n  bottom: 12px;\n  width: 100%;\n  max-width: clamp(360px, 28vw, 500px);\n}\n\n.truck-illustration img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.right-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n}\n\n.row {\n  display: flex;\n  align-items: stretch;\n}\n\n.vision-row,\n.mission-row {\n  align-items: stretch;\n}\n\n.vision-image,\n.mission-image,\n.vision-text,\n.mission-text {\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.vision-image,\n.mission-image {\n  flex: 1 1 50%;\n  display: flex;\n}\n\n.mission-image img,\n.vision-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0px !important;\n}\n\n.mission-text,\n.vision-text {\n  background: linear-gradient(180deg, #D0171F 0%, #750D13 100%);\n  color: #fff;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1 1 50%;\n  min-height: 240px;\n}\n\n.mission-text h3,\n.vision-text h3 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0 0 16px;\n}\n\n.mission-text p,\n.vision-text p {\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* About Team Showcase */\n.about-team-showcase {\n  padding: 80px 0;\n  background: #FFF6F6;\n}\n\n.team-showcase-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.team-showcase-header h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 16px 0 0;\n  color: var(--text);\n}\n\n.team-members-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 30px;\n}\n\n.team-member-card {\n  padding: 30px 20px;\n  border-radius: 12px;\n  border-top-right-radius: 60px;\n  border-bottom-right-radius: 60px;\n  box-shadow: none;\n  transition: transform 0.3s ease;\n}\n\n.team-member-card:hover {\n  transform: translateY(-5px);\n}\n\n.member-photo {\n  width: 100%;\n  max-width: 356px;\n  aspect-ratio: 1 / 1;\n  margin: 0 auto 20px;\n  border-radius: 0 60px 60px 0;\n  overflow: hidden;\n  border: 2px solid var(--primary);\n}\n\n.member-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.team-member-card h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0 0 8px;\n  color: var(--text);\n}\n\n.team-member-card p {\n  font-size: 0.9rem;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* About Location */\n.about-location {\n  position: relative;\n  padding: 80px 0;\n  background: transparent;\n  overflow: hidden;\n}\n\n.about-location .section-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.about-location .section-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: brightness(.85);\n}\n\n.location-content {\n  position: relative;\n  z-index: 1;\n}\n\n.location-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.location-header h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 16px 0 0;\n  color: var(--text);\n}\n\n.location-map-container {\n  position: relative;\n  z-index: 1;\n  background: transparent;\n  border-radius: 12px;\n  padding: min(5vw, 48px) 0;\n}\n\n.world-map {\n  display: grid;\n  place-items: center;\n}\n\n.world-map img {\n  width: min(980px, 90%);\n  height: auto;\n  display: block;\n}\n\n.location-info-card {\n  position: absolute;\n  left: 42%;\n  transform: translateX(-50%);\n  bottom: clamp(12px, 2.5vw, 24px);\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  background: #fff;\n  max-width: 500px;\n  min-width: 150px;\n  padding: clamp(16px, 2.2vw, 28px);\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .12);\n}\n\n.location-image {\n  width: clamp(96px, 12vw, 140px);\n  aspect-ratio: 3 / 2;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.location-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.location-details h3 {\n  font-size: clamp(1.1rem, 2.2vw, 1.5rem);\n  font-weight: 700;\n  margin: 0 0 8px;\n  color: var(--text);\n}\n\n.location-role {\n  font-size: clamp(.9rem, 1.8vw, 1rem);\n  font-weight: 600;\n  color: var(--primary);\n  margin: 0 0 12px;\n}\n\n.location-description {\n  font-size: clamp(.9rem, 1.8vw, 1rem);\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Contact Page Styles */\n.contact-hero {\n  position: relative;\n  padding: 140px 0 120px;\n  color: #fff;\n  overflow: hidden;\n}\n\n/* Card */\n.card {\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Contact Info */\n.contact-info {\n  background: #f8f9fa;\n}\n\n.grid {\n  display: grid;\n  gap: 30px;\n}\n\n.grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.info-card {\n  background: #fff;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.info-card h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 20px;\n  color: var(--text);\n}\n\n.info-card p {\n  margin: 0 0 10px;\n  color: var(--muted);\n}\n\n.info-card a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.info-card a:hover {\n  text-decoration: underline;\n}\n\n.contact-hero::before {\n  filter: brightness(0.55);\n}\n\n.contact-hero .hero-inner {\n  max-width: var(--container);\n  position: relative;\n}\n\n.contact-hero .hero-cta {\n  margin-top: 8px;\n  position: absolute;\n  right: 14%;\n  bottom: -10px;\n}\n\n.contact-inquiry .section-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted);\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.contact-inquiry h2 {\n  font-size: 40px;\n  line-height: 1.15;\n  margin: 0 0 16px;\n}\n\n.inquiry-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n}\n\n.inquiry-visual img {\n  width: min(360px, 90%);\n  height: auto;\n  display: block;\n  margin-top: 20px;\n}\n\n.inquiry-card {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.contact-inquiry .contact-form {\n  max-width: none;\n  margin-top: 20px;\n}\n\n.contact-inquiry .row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.contact-inquiry input,\n.contact-inquiry textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.contact-inquiry textarea {\n  margin-bottom: 20px;\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-inquiry .actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 6px;\n}\n\n/* Toast notifications */\n.toast-container {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 20px;\n  display: flex;\n  justify-content: center;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.toast-container .toast {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  padding: 12px 16px;\n  border-radius: 12px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, .18);\n  backdrop-filter: blur(6px);\n  transform: translateY(-16px);\n  opacity: 0;\n  transition: transform .25s ease, opacity .25s ease;\n  pointer-events: auto;\n}\n\n.toast-container.is-visible .toast {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.toast.success {\n  background: linear-gradient(180deg, rgba(30, 142, 62, .96), rgba(20, 109, 46, .96));\n}\n\n.toast.error {\n  background: linear-gradient(180deg, rgba(208, 23, 31, .96), rgba(117, 13, 19, .96));\n}\n\n.toast-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, .9);\n}\n\n.toast-message {\n  font-weight: 600;\n  letter-spacing: .2px;\n}\n\n.toast-title {\n  font-weight: 800;\n  letter-spacing: .3px;\n}\n\n.btn-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid #eee;\n  background: #fff;\n  color: var(--primary);\n  font-weight: 800;\n  cursor: pointer;\n}\n\n/* Services Core Logistics */\n.services-core-logistics {\n  background: #FFF6F6;\n  min-height: 100vh;\n  position: relative;\n}\n\n.services-core-logistics .section-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted);\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.services-core-logistics h2 {\n  font-size: 40px;\n  line-height: 1.15;\n  margin: 0 0 24px;\n  color: var(--text);\n  font-weight: 700;\n}\n\n.core-logistics-sticky-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  min-height: 100vh;\n}\n\n.sticky-left {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 40px 0;\n}\n\n.scrollable-right {\n  padding: 40px 0;\n}\n\n.service-showcase-item {\n  margin-bottom: 80px;\n  position: relative;\n}\n\n.service-showcase-item:last-child {\n  margin-bottom: 0;\n}\n\n.service-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: #b31218;\n  color: white;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\n\n.service-showcase-item h3 {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--text);\n  margin: 0 0 20px;\n}\n\n.service-image {\n  margin-bottom: 20px;\n}\n\n.service-image img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.service-description {\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.cta-container {\n  margin-top: auto;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .core-logistics-sticky-container {\n    grid-template-columns: 1fr;\n    gap: 40px;\n    min-height: auto;\n  }\n\n  .sticky-left {\n    position: static;\n    height: auto;\n    padding: 20px 0;\n  }\n\n  .scrollable-right {\n    padding: 20px 0;\n  }\n\n  .services-core-logistics h2 {\n    font-size: 32px;\n  }\n\n  .service-showcase-item h3 {\n    font-size: 28px;\n  }\n\n  .service-number {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n\n  .service-showcase-item {\n    margin-bottom: 60px;\n  }\n}\n\n/* Services How We Work */\n.services-how-we-work {\n  background: #fff;\n}\n\n.services-how-we-work .section-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted);\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.services-how-we-work h2 {\n  font-size: 40px;\n  line-height: 1.15;\n  margin: 0 0 16px;\n  color: var(--text);\n}\n\n.how-we-work-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n}\n\n.how-we-work-visual {\n  margin-top: 20px;\n}\n\n.how-we-work-visual img {\n  width: 100%;\n  height: auto;\n  max-width: 400px;\n}\n\n.features-accordion {\n  max-width: 100%;\n}\n\n.feature-item {\n  border-bottom: 1px solid #eee;\n}\n\n.feature-toggle {\n  width: 100%;\n  padding: 14px 6px;\n  background: transparent;\n  border: none;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  text-align: left;\n  color: #b31218;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.feature-toggle:hover {\n  color: #8e0e13;\n}\n\n.feature-icon {\n  width: 22px;\n  height: 22px;\n  display: inline-grid;\n  place-items: center;\n  border-radius: 50%;\n  background: #ffe6e7;\n  color: #b31218;\n  font-size: 14px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.feature-toggle:hover .feature-icon {\n  background: #ffd1d3;\n}\n\n.feature-panel {\n  padding: 0 6px 14px;\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.5;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .how-we-work-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .services-how-we-work h2 {\n    font-size: 32px;\n  }\n\n  .how-we-work-visual {\n    text-align: center;\n  }\n}\n\n/* Services Industries */\n.services-industries {\n  background: #fff;\n  padding: 80px 0;\n}\n\n.industries-header {\n  margin-bottom: 60px;\n  text-align: center;\n}\n\n.services-industries .section-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted);\n  font-weight: 600;\n  margin-bottom: 10px;\n  justify-content: center;\n}\n\n.services-industries .section-badge .badge-dot {\n  background: var(--primary);\n  border-radius: 100%;\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n}\n\n.services-industries h2 {\n  font-size: 40px;\n  line-height: 1.15;\n  margin: 0;\n  color: var(--text);\n  font-weight: 700;\n}\n\n.industries-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 24px;\n}\n\n.industry-card {\n  display: flex;\n  flex-direction: column;\n  opacity: 0.7;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  transform-origin: center;\n  will-change: transform;\n  position: relative;\n  z-index: 1;\n}\n\n.industry-card:hover {\n  transform: scale(1.05) !important;\n  opacity: 1;\n  z-index: 2;\n}\n\n.industry-image-wrapper {\n  position: relative;\n  /* width: 100%; */\n  /* aspect-ratio: 4 / 3; */\n  /* Commented to avoid forcing crop */\n  /* border-radius: 12px; */\n  /* Images already have correct shape */\n  /* overflow: hidden; */\n  /* Allow full image to show */\n  margin-bottom: 16px;\n}\n\n/* .industry-image-wrapper.highlighted {\n  border-top: 4px solid var(--primary);\n  border-right: 4px solid var(--primary);\n  border-radius: 12px;\n} */\n\n.industry-image {\n  /* width: 100%; */\n  /* Let intrinsic size drive layout */\n  /* height: 100%; */\n  /* object-fit: cover; */\n  /* Commented to prevent cropping */\n  /* border-radius: 12px; */\n  transition: opacity 0.3s ease;\n}\n\n\n.industry-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text);\n  margin: 0 0 12px;\n  text-align: center;\n}\n\n.industry-description {\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0;\n  text-align: center;\n}\n\n@media (max-width: 1400px) {\n  .industries-grid {\n    gap: 20px;\n  }\n\n}\n\n@media (max-width: 1200px) {\n  .industries-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-industries {\n    padding: 60px 0;\n  }\n\n  .services-industries h2 {\n    font-size: 32px;\n  }\n\n  .industries-grid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .industry-image-wrapper {\n    aspect-ratio: 16 / 9;\n  }\n}\n\n/* Contact FAQ */\n.faq-section {\n  background: #fff7f7;\n}\n\n.faq-section h2 {\n  text-align: center;\n  margin: 6px 0 20px;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.faq-list {\n  max-width: 760px;\n  margin: 0 auto;\n}\n\n.faq-item {\n  border-bottom: 1px solid #eee;\n}\n\n.faq-toggle {\n  width: 100%;\n  padding: 14px 6px;\n  background: transparent;\n  border: none;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  text-align: left;\n  color: #b31218;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.faq-icon {\n  width: 22px;\n  height: 22px;\n  display: inline-grid;\n  place-items: center;\n  border-radius: 50%;\n  background: #ffe6e7;\n  color: #b31218;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.faq-panel {\n  padding: 0 6px 14px;\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Responsive Design for About Page */\n@media (max-width: 1024px) {\n  .pillars-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .about-guiding-pillars {\n    min-height: clamp(420px, 70vh, 640px);\n  }\n\n  .who-we-are-content,\n  .timeline-content {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .mission-vision-content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .row {\n    flex-direction: column;\n  }\n\n  .what-drives-us {\n    flex-basis: auto;\n    padding: 24px;\n    max-width: none;\n  }\n\n  .vision-image,\n  .mission-image {\n    height: auto;\n  }\n\n  .truck-illustration {\n    position: static;\n    margin-top: 12px;\n    max-width: 260px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .pillars-grid,\n  .team-members-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .location-info-card {\n    position: static;\n    transform: none;\n    margin: 16px auto 0;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .timeline-years {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .year-item {\n    white-space: nowrap;\n  }\n}\n\n/* Client & Partners - Logo Carousel */\n.logo-carousel {\n  position: relative;\n  overflow: hidden;\n  margin-top: 24px;\n  z-index: 2;\n}\n\n.logo-track {\n  display: flex;\n  align-items: center;\n  gap: clamp(36px, 6vw, 80px);\n  animation: logo-scroll 60s linear infinite;\n  will-change: transform;\n  width: max-content;\n}\n\n.logo-item img {\n  display: block;\n  height: clamp(28px, 5vw, 52px);\n  width: auto;\n  object-fit: contain;\n  filter: saturate(0) contrast(1.0) brightness(0.9);\n  transition: filter .2s ease;\n}\n\n.logo-item img:hover {\n  filter: none;\n}\n\n@keyframes logo-scroll {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@media (max-width: 920px) {\n  .inquiry-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Testimonials */\n.testimonials {\n  --card-radius: 12px;\n  --card-border: #f0e6e6;\n  --dot: #bfbfbf;\n  --dot-active: #111;\n}\n\n.testimonials.alt {\n  background: #fff6f6;\n}\n\n.testimonials .testi-head {\n  text-align: center;\n  margin-bottom: 26px;\n}\n\n.testimonials .testi-head .eyebrow {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: var(--muted);\n}\n\n.testimonials .testi-head .eyebrow::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--primary);\n  display: inline-block;\n}\n\n.testimonials h2 {\n  font-size: 40px;\n  font-weight: 800;\n  margin: 8px 0 0;\n}\n\n.testimonials .testi-carousel-wrapper {\n  position: relative;\n  margin-top: 28px;\n}\n\n.testimonials .testi-carousel-container {\n  overflow: hidden;\n  margin: 0 50px;\n}\n\n.testimonials .testi-carousel {\n  display: flex;\n  gap: 24px;\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n}\n\n.testimonials .testi-carousel .testi-card {\n  flex: 0 0 calc((100% - 48px) / 3);\n  min-width: 0;\n}\n\n.testimonials .carousel-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid #ddd;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.testimonials .carousel-btn:hover:not(:disabled) {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(227, 27, 35, 0.3);\n}\n\n.testimonials .carousel-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.testimonials .carousel-btn-prev {\n  left: 0;\n}\n\n.testimonials .carousel-btn-next {\n  right: 0;\n}\n\n.testimonials .carousel-btn svg {\n  width: 20px;\n  height: 20px;\n  color: currentColor;\n}\n\n.testimonials .testi-card {\n  background: #fff;\n  border: 1px solid var(--card-border);\n  border-radius: var(--card-radius);\n  padding: 26px 22px 22px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, .03);\n}\n\n.testimonials .testi-card .quote {\n  margin: 0 0 24px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: #111;\n}\n\n.testimonials .byline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.testimonials .byline img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.testimonials .person .name {\n  font-weight: 700;\n}\n\n.testimonials .person .role {\n  color: var(--muted);\n}\n\n.testimonials .byline .bubble {\n  margin-left: auto;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #ffe6e7;\n  color: #d71920;\n  font-size: 18px;\n}\n\n.testimonials .dots {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.testimonials .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--dot);\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.testimonials .dot.is-active {\n  width: 7px;\n  height: 7px;\n  background: var(--dot-active);\n}\n\n@media (max-width: 1024px) {\n  .testimonials .testi-carousel .testi-card {\n    flex: 0 0 calc((100% - 24px) / 2);\n  }\n\n  .testimonials .testi-carousel-container {\n    margin: 0 50px;\n  }\n}\n\n@media (max-width: 768px) {\n  .testimonials .testi-carousel .testi-card {\n    flex: 0 0 100%;\n  }\n\n  .testimonials .testi-carousel-container {\n    margin: 0 40px;\n  }\n\n  .testimonials .carousel-btn {\n    width: 36px;\n    height: 36px;\n  }\n\n  .testimonials .carousel-btn svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* Scroll animations */\n.scroll-animate {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animate.animate-in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.scroll-animate-left {\n  opacity: 0;\n  transform: translateX(-30px);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animate-left.animate-in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.scroll-animate-right {\n  opacity: 0;\n  transform: translateX(30px);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animate-right.animate-in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.scroll-animate-scale {\n  opacity: 0;\n  transform: scale(0.9);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animate-scale.animate-in {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Staggered animations for multiple elements */\n.scroll-animate-stagger {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n\n.scroll-animate-stagger.animate-in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.scroll-animate-stagger:nth-child(1) {\n  transition-delay: 0.1s;\n}\n\n.scroll-animate-stagger:nth-child(2) {\n  transition-delay: 0.2s;\n}\n\n.scroll-animate-stagger:nth-child(3) {\n  transition-delay: 0.3s;\n}\n\n.scroll-animate-stagger:nth-child(4) {\n  transition-delay: 0.4s;\n}\n\n.scroll-animate-stagger:nth-child(5) {\n  transition-delay: 0.5s;\n}\n\n.scroll-animate-stagger:nth-child(6) {\n  transition-delay: 0.6s;\n}\n\n/* Counter animation */\n.counter-animate {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.8s ease-out, transform 0.8s ease-out;\n}\n\n.counter-animate.animate-in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Parallax effect */\n.parallax-slow {\n  transform: translateY(0);\n  transition: transform 0.1s ease-out;\n}\n\n/* Hover animations */\n.hover-lift {\n  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;\n}\n\n.hover-lift:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n}\n\n.hover-scale {\n  transition: transform 0.3s ease-out;\n}\n\n.hover-scale:hover {\n  transform: scale(1.05);\n}\n\n/* Fade in with blur effect */\n.scroll-animate-blur {\n  opacity: 0;\n  filter: blur(10px);\n  transform: translateY(30px);\n  transition: opacity 0.8s ease-out, filter 0.8s ease-out, transform 0.8s ease-out;\n}\n\n.scroll-animate-blur.animate-in {\n  opacity: 1;\n  filter: blur(0);\n  transform: translateY(0);\n}\n\n/* Animated word reveal helpers */\n.word-mask {\n  display: inline-block;\n  overflow: hidden;\n}\n\n.word {\n  display: inline-block;\n}\n\n.animated-line {\n  display: block;\n}\n\n/* Scroll to Top Button */\n.scroll-to-top {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  background: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(20px);\n  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease, background-color 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.scroll-to-top:hover {\n  background: #c4161d;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.scroll-to-top:active {\n  transform: translateY(0);\n}\n\n.scroll-to-top.visible {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.scroll-to-top svg {\n  width: 20px;\n  height: 20px;\n}\n\n@media (max-width: 768px) {\n  .scroll-to-top {\n    width: 44px;\n    height: 44px;\n    bottom: 20px;\n    right: 20px;\n  }\n\n  .scroll-to-top svg {\n    width: 18px;\n    height: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
